import { makeAutoObservable } from 'mobx';

import { isInFacebookBrowser } from '@/utils/utils';

export const pwaStore = makeAutoObservable({
  status: 0, // 0 初始化 1 待安装 2 已安装 3 安装中
  setStatus(status: number) {
    this.status = status;
  },
  init() {
    if (
      isInFacebookBrowser() ||
      !SingletonPrompt.getInstance().getInstalled() ||
      SingletonPrompt.getInstance().getPrompt()
    ) {
      this.status = 1;
    } else {
      this.status = 2;
    }
  }
});
